<div class="shapes-container flex flex-col">
  <div class="shapes-description mb-[20px]">
    Configure which geometry types can be captured on this bid item and how device measurements map to Quantity or custom fields defined in the Fields tab.
  </div>

  @if (availableTypeOptions.length) {
    <div class="flex justify-start items-center mb-[20px]">
      <div
        (click)="addShape()"
        class="add-shape-btn flex items-center gap-[8px] text-type-9 cursor-pointer"
      >
        <mat-icon svgIcon="blue-plus" class="add-icon"></mat-icon>
        Add geometry type
      </div>
    </div>
  }

  @for (shape of shapes; track shape.id) {
    <div class="shape-accordion">
      <div
        [class.is-expanded]="selectedShapeId === shape.id"
        [class.has-error]="shape.showError"
        class="shape-accordion-wrapper border-[1px] border-[#C2C8DC] rounded-[4px] p-[16px]"
      >
        <div
          (click)="toggleShape(shape)"
          class="shape-accordion-header flex justify-between items-center cursor-pointer"
        >
          <div class="shape-accordion-heading text-type-13 uppercase">
            {{ getShapeLabel(shape) }}
          </div>
          <div class="flex items-center gap-[8px]">
            <mat-icon
              [svgIcon]="selectedShapeId === shape.id ? 'chevron-up' : 'chevron-down'"
              class="accordion-chevron"
            />
            <button mat-icon-button [matMenuTriggerFor]="shapeMenu" (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #shapeMenu="matMenu">
              <button mat-menu-item (click)="confirmDeleteShape(shape, $event)">
                <mat-icon svgIcon="trash"></mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="shape-accordion-content">
          @if (!shape.form.get('type')?.value) {
            <app-dropdown
              [options]="availableTypeOptions"
              [parentFormGroup]="shape.form"
              [error]="shape.showError ? 'Please select a geometry type' : ''"
              class="mb-[20px]"
              controlName="type"
              label="Geometry Type"
              placeholder="Select geometry type"
            />
          }

          @if (shape.form.get('type')?.value) {
            <app-dropdown
              [enableMultiple]="true"
              [options]="fieldOptions"
              [parentFormGroup]="shape.form"
              [showCount]="true"
              class="mb-[20px]"
              controlName="fields"
              label="Map Measurements To"
              placeholder="Select Quantity or custom fields"
              selectionString="selected"
            />

            <div class="source-hint mb-[12px]">
              <div>{{ getSourceHint(shape) }}</div>
              <div>Supports math operators: +, -, *, / (e.g. {{ getSourceExample(shape) }})</div>
            </div>

            <!-- Accordions for each selected field mapping -->
            @for (fieldId of shape.form.get('fields')?.value; track fieldId) {
              <div class="field-sub-accordion">
                <div
                  [class.is-expanded]="shape.expandedFieldId === fieldId"
                  class="field-sub-wrapper border-[1px] border-[#E9ECF4] rounded-[4px] p-[12px]"
                >
                  <div
                    (click)="toggleFieldAccordion(shape, fieldId)"
                    class="field-sub-header flex justify-between items-center cursor-pointer"
                  >
                    <div class="field-sub-heading text-type-13">
                      {{ getFieldLabel(fieldId) }}
                    </div>
                    <mat-icon
                      [svgIcon]="shape.expandedFieldId === fieldId ? 'chevron-up' : 'chevron-down'"
                      class="accordion-chevron"
                    />
                  </div>
                  <div class="field-sub-content">
                    <app-text-area
                      [parentFormGroup]="getFieldSubForm(shape, fieldId)"
                      controlName="value"
                      label="Source Expression"
                      [placeholder]="'e.g. ' + getSourceExample(shape)"
                    />
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }

  @if (shapes.length) {
    <div class="flex justify-end mt-[8px]">
      <app-primary-button
        (handleClick)="save()"
        [isDisabled]="!isDirty"
      >Save</app-primary-button>
    </div>
  }
</div>
